import React, { Component } from 'react';
import logo from './logo.svg';
import testImg from './img/ingreso.png';
import './App.css';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import './pricing.css';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import CardMedia from '@material-ui/core/CardMedia';
import InfoDialog from './InfoDialog.js'

import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';


import Typography from '@material-ui/core/Typography';
import Responsive from 'react-responsive';
const Mobile = props => <Responsive {...props} maxWidth={767} />;
const Default = props => <Responsive {...props} minWidth={768} />;
// import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
// import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import SkipNextIcon from '@material-ui/icons/SkipNext';


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  button: {
    margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    // lineHeight: 1.5,
    backgroundColor: 'rgb(114, 165,199)',
    borderColor: 'rgb(114, 165,199)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    // width: 200,
    textAlign: "center",
    color: "#203b60",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  card: {
    display: 'flex',
    width: 200,
    height: 230,
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '24px',
    textAlign: 'center'

    // height:50
  },
  details: {
    display: 'flex',
    flexDirection: 'column',

  },
  content: {
    flex: '1 0 auto',
    textAlign: 'center'
  },
  infoIcon: {

    // backgroundColor: 'rgb(114, 165,199)',


    '&:hover': {
      // backgroundColor: '#203b60',
      // borderColor: '#203b60',
      color: '#3f51b5',
      cursor: 'pointer'
    },
    '&:active': {
      boxShadow: 'none',

    },
  },


  Mcard: {
    display: 'flex',
    marginTop: '10px',
    marginBottom: '10px',
    width: '100%',
    padding: '0px',
    paddingLeft: '10%',
    // paddingTop:'10%'
    // height:'120px'
    // alignItems:'right'

  },
  Mdetails: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: "0px",
    // paddingTop:"10%",
    // paddingBottom:'10px',


  },
  Mcontent: {
    flex: '1 0 auto',
    // paddingTop: '10px',
    marginTop: '15%',

    padding: "0px"
    // textAlign:'center'
  },
  Mcover: {
    width: "100px",
    height: "50px"
  },
  Mcontrols: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  MplayIcon: {
    height: 38,
    width: 38,
  },

});

class AppsGrid extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: 0,
      selected_apps: [],
      openInfoDialog:false,
      cardInfo:{}
    }
    this.userChange = this.userChange.bind(this);
    this.showInfoDialog = this.showInfoDialog.bind(this);
    this.closeInfoDialog = this.closeInfoDialog.bind(this);

  }

  userChange(event) {
    this.setState({
      users: event.target.value
    })
  }

  getTotalMonth() {
    var total;

    var users = (this.props.users * this.props.prices.user)
    var total_users = users - (users * this.props.prices.discount_new_user)

    return total_users
  }

  handleApp = app => event => {


    this.props.setSelectedApps(app)


  };

  showInfoDialog(item){
    console.log("SHOWING DIALOG")


    //temp
    item['description'] = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae ultrices odio, at efficitur lacus. Etiam ullamcorper ligula erat. Proin sagittis lectus ut ligula molestie, vitae porta diam rutrum. Praesent dolor lectus, vestibulum ac varius ut, lobortis eget lacus. Duis ac bibendum nibh, eu hendrerit dui. Aenean auctor consequat odio, rutrum scelerisque arcu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec mollis facilisis imperdiet. Mauris nulla libero, facilisis nec cursus a, imperdiet id libero. Aliquam rutrum sem quis massa posuere viverra. Nullam sit amet risus ac ligula blandit tristique. Sed rhoncus semper ipsum."

    
    this.setState({
      openInfoDialog:true,
      cardInfo:item
    })

  }

  closeInfoDialog(){
    this.setState({
      openInfoDialog:false
    })
  }






  render() {
    const { classes, theme } = this.props;
    return (
      // <div>

      <div  className="row text-center" >
   

      <InfoDialog open={this.state.openInfoDialog} close={this.closeInfoDialog} data={this.state.cardInfo}/>
       
          {this.props.prices.map((item, index) => (


            <React.Fragment>
              <Default>
              
                <div  className="col-auto">
                 
                    <Card key={item.id} className={classes.card}>




                      <div className={classes.details}>


                        <img className="app-card-img  img-fluid" src={'./img/' + item.img}></img>




                        <CardContent className={classes.content}>
                          {/* <Typography component="h5" variant="h5">
                  {item.name}
    </Typography> */}
                          <div className="app-card-title" >
                            {item.name}
                          </div>
                          <div className="app-card-price">
                            ${item[this.props.period]} USD / Mes
                </div>

                          <div className="row" style={{ paddingLeft: '40%' }}>
                            {/* <div style={{ paddingLeft: '40%' }}> */}

                            <div style={{ paddingTop: "12px" }}>
                              <InfoOutlined
                                color="disabled"
                                onClick={() => this.showInfoDialog(item)}
                                classes={{
                                  root: classes.infoIcon,

                                }} />
                            </div>

                            <Checkbox
                              checked={this.props.selected_apps.map(function (app) { return app.id }).includes(item.id)}
                              onChange={this.handleApp(item)}
                              value="checkedB"
                              color="primary"
                            />
                            {/* </div> */}




                          </div>



                        </CardContent>


                      </div>


                    </Card>
                  
                </div>
               
              </Default>

              <Mobile>

                <div className="col-md-12">

                  <Card className={classes.Mcard}>
                    {/* <CardMedia
                  className={classes.Mcover}
                  image={'/img/' + item.img}
                  title="Live from space album cover"
                /> */}
                    <div className="app-card-img-container">
                      <img className="app-card-img  img-fluid" src={'./img/' + item.img}></img>
                    </div>


                    <div className={classes.Mdetails}>
                      <CardContent className={classes.Mcontent}>
                        <div className="app-card-title" >
                          {item.name}
                        </div>
                        <Typography variant="subtitle1" color="textSecondary">
                          ${item[this.props.period]} USD / Mes
          </Typography>
                        <div className="row" style={{ paddingLeft: '40%' }}>

                          <div style={{ paddingTop: "12px" }}>
                            <InfoOutlined
                              color="disabled"
                              onClick={this.showInfoDialog}
                              classes={{
                                root: classes.infoIcon,

                              }} />
                          </div>
                          {/* <div className="col-md-1"> */}
                          {/* <Checkbox color="default" value="checkedG" /> */}
                          <Checkbox
                            // checked={this.state.selected_apps.includes(item.id)?true:false}
                            checked={this.props.selected_apps.map(function (app) { return app.id }).includes(item.id)}
                            onChange={this.handleApp(item)}
                            value="checkedB"
                            color="primary"
                          />
                          {/* </div> */}



                        </div>
                      </CardContent>
                      <div className={classes.Mcontrols}>

                      </div>
                    </div>

                  </Card>


                </div>
              </Mobile>
            </React.Fragment>








          ))}
       {/* </React.Fragment> */}
       </div>



    );
  }
}


AppsGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppsGrid);
// export default AppsGrid;